import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IGetAdminAwardsParams,
  IGetAdminAwardsResponse,
  IGetAwardTypesResponse,
  ICreateAwardParams,
  IEditAwardParams,
  IMutationResponse,
} from '../../../interface/classveew-admin/admin-award.interface';
import { IErrorResponse } from '../../../interface/main.interface';
import {
  getAdminAwards,
  getAwardTypes,
  createAdminAward,
  editAdminAward,
  deleteAdminAward,
  toggleAdminAward,
} from '../../../services/classveew-admin';
import { normalizeAxiosError } from '../../../utility/axiosErrorHandler';
import { tr } from '../../../i18n/i18n';

export const fetchAdminAwards = createAsyncThunk<
  IGetAdminAwardsResponse,
  IGetAdminAwardsParams,
  { rejectValue: IErrorResponse }
>('admin-award/fetch-all', async (params, { rejectWithValue }) => {
  try {
    const response = await getAdminAwards(params);
    return response.data;
  } catch (err) {
    return rejectWithValue(
      normalizeAxiosError(err, tr('admin_award.error_fetch_awards', 'Failed to fetch awards')),
    );
  }
});

export const fetchAwardTypes = createAsyncThunk<
  IGetAwardTypesResponse,
  void,
  { rejectValue: IErrorResponse }
>('admin-award/fetch-types', async (_, { rejectWithValue }) => {
  try {
    const response = await getAwardTypes();
    return response.data;
  } catch (err) {
    return rejectWithValue(
      normalizeAxiosError(
        err,
        tr('admin_award.error_fetch_award_types', 'Failed to fetch award types'),
      ),
    );
  }
});

export const createAward = createAsyncThunk<
  IMutationResponse,
  ICreateAwardParams,
  { rejectValue: IErrorResponse }
>('admin-award/create', async (data, { rejectWithValue }) => {
  try {
    const response = await createAdminAward(data);
    return response.data;
  } catch (err) {
    return rejectWithValue(
      normalizeAxiosError(err, tr('admin_award.error_create_award', 'Failed to create award')),
    );
  }
});

export const editAward = createAsyncThunk<
  IMutationResponse,
  { id: string; data: IEditAwardParams },
  { rejectValue: IErrorResponse }
>('admin-award/edit', async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await editAdminAward(id, data);
    return response.data;
  } catch (err) {
    return rejectWithValue(
      normalizeAxiosError(err, tr('admin_award.error_update_award', 'Failed to update award')),
    );
  }
});

export const deleteAward = createAsyncThunk<
  IMutationResponse,
  string,
  { rejectValue: IErrorResponse }
>('admin-award/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await deleteAdminAward(id);
    return response.data;
  } catch (err) {
    return rejectWithValue(
      normalizeAxiosError(err, tr('admin_award.error_delete_award', 'Failed to delete award')),
    );
  }
});

export const toggleAward = createAsyncThunk<
  IMutationResponse,
  string,
  { rejectValue: IErrorResponse }
>('admin-award/toggle', async (id, { rejectWithValue }) => {
  try {
    const response = await toggleAdminAward(id);
    return response.data;
  } catch (err) {
    return rejectWithValue(
      normalizeAxiosError(err, tr('admin_award.error_toggle_award', 'Failed to toggle award status')),
    );
  }
});
